import { createFeatureSelector } from '@ngrx/store';

import { State } from '@client-parents/reducers/client-parent-details.reducers';

export const selectClientParentDetailsState = createFeatureSelector<State>('clientParentDetails');
